import { Questionaire, QuestionaireQuestion, QuestionaireOptionAnswers } from "@/domain/entities/Questionaire";
import { BaseQuestionaireQuestionResponse, BaseQuestionaireResponse } from "../dto/Questionaires/BaseQuestionaireResponse";

// const mapQuestionAnswers = (options: string[], questionType: string): QuestionaireOptionAnswers[] | null => {
//     if (options) {
//         return options.map(opt => ({ title: opt, answers: 2 }))
//     }
//     if (questionType == 'rating') {
//         return Array(5).fill("").map((_, index) => ({
//             title: `${index + 1}`,
//             answers: 3
//         }))
//     }
//     return null
// }

const mapQuestionOptions = (options: string[], questionType: string): string[] | null => {
    if (options) {
        return options.map(opt => opt)
    }
    if (questionType == 'rating') {
        return Array(5).fill("").map((_, index) => `${index + 1}`)
    }
    return null
}
const mapQuestion = (data: BaseQuestionaireQuestionResponse): QuestionaireQuestion => {
    return {
        id: `${data.id}`,
        question: data.question || "",
        type: data.type || "",
        answers: data.answer_stats ? Object.entries(data.answer_stats).map(([key, value]) => ({
            title: key,
            answers_qtd: value,
        })) : [],
        options: mapQuestionOptions(data.options, data.type),
        required: !!data.required,
        order: data.order || 0,
    }
}

const toEntity = (data: BaseQuestionaireResponse): Questionaire => ({
    id: `${data.id}`,
    title: data.title || "",
    description: data.description || "",
    active: !!data.active,
    starts_at: data.starts_at || "",
    ends_at: data.ends_at || "",
    questions: data.questions?.map(mapQuestion) || [],
    created_at: data.created_at || "",
    answers_qtd: data?.answered_count || 0
})

export default { toEntity }
